<style lang="less">
@import "./login.less";
// .login-con{width:580px;margin-left:-290px;}
.titleClass {
  color: #fff;
  font-size: 30px;
  text-align: center;
  margin-bottom: 50px;
}
</style>

<template>
  <div class="login">
    <div>
      <div class="login-con">
        <div class="titleClass">{{ name }}</div>
        <Card icon="log-in" :bordered="false">
          <div slot="title" class="login-con-header">
            <h3>{{ $t("loginArea.title") }}</h3>
            <language
              v-if="config.useI18n"
              @on-lang-change="setLocal"
              class="languageStyle"
              :lang="local"
            />
          </div>
          <div style="padding: 0 40px">
            <!-- <div style="margin-right:20px;width:170px;text-align: center;">
              <img class="login-img" :src="logoimg">
            </div> -->
            <LoginForm
              ref="loginForm"
              @on-success-valid="handleSubmit"
              @viewNotice="viewNotice"
            ></LoginForm>
          </div>
        </Card>
      </div>
    </div>
  </div>
</template>

<script>
import LoginForm from "_c/login-form/login-form";
import LoginFormEnterprise from "_c/login-form/login-form-enterprise";
import { mapActions, mapMutations } from "vuex";
import notices from "./notices";
import { get_website_data } from "@/api/chuku";
import logoimg from "@/assets/images/logo-max.png";
import Language from "@/components/main/components/language";
import config from "@/config";
export default {
  data() {
    return {
      loginWrapper: "loginWrapper",
      account_type: 1, //默认开发者帐号
      logoimg: logoimg,
      config: config,
      name: "沛城",
    };
  },
  components: {
    LoginForm,
    LoginFormEnterprise,
    Language,
  },
  computed: {
    local() {
      return this.$store.state.app.local;
    },
  },
  methods: {
    ...mapMutations(["setLocal"]),
    ...mapActions(["handleLogin", "getUserInfo"]),
      setLocal(lang) {
    this.$store.commit('setLocal', lang);
    console.log('当前语言:', lang); // 打印切换的语言值
  },
    onClickTabs(name) {
      if (name === "name1") {
        this.account_type = 1;
      } else if (name === "name2") {
        this.account_type = 2;
      }
    },
    handleSubmit({ userName, password }) {
       console.log('this.$i18n.locale',this.$i18n.locale);
      this.$refs.loginForm.setLoading(true);
      let admin_lang_type;
      if (this.$i18n.locale=='en-US') {
        admin_lang_type='en'
      }else{
        admin_lang_type='zh'
      }
      this.handleLogin({
        userName,
        password,
        account_type: this.account_type,
        admin_lang_type:admin_lang_type
      }).then((res) => {
        if (res.result === 0) {
          this.$Message.success(res.errorMsg);
          this.$router.push({
            name: this.$config.homeName,
          });
          this.$refs.loginForm.setLoading(false);
        } else {
          this.$refs.loginForm.setLoading(false);
          this.$Message.error(res.errorMsg);
        }
      });
    },
    /**
     * 企业员工提交
     * @param userName
     * @param password
     */
    handleSubmitEnterprise({ userName, password }) {
      this.$refs.loginForm2.setLoading(true);
      this.handleLogin({
        userName,
        password,
        account_type: this.account_type,
         admin_lang_type:admin_lang_type
      }).then((res) => {
        if (res.result === 0) {
          this.$Message.success(this.$t('登录成功'));
          this.$router.push({
            name: this.$config.homeName,
          });
          this.$refs.loginForm2.setLoading(false);
        } else {
          this.$refs.loginForm2.setLoading(false);
          this.$Message.error(res.errorMsg);
        }
      });
    },
    viewNotice() {
      let vm = this;
      let config = {
        title: "隐私政策",
        loading: true,
        width: 800,
        render: (h) => {
          return h(notices, {
            props: {
              $store: vm.$store,
            },
          });
        },
        onOk: function () {
          vm.$Modal.remove();
        },
      };
      this.$Modal.success(config);
    },
  },
  mounted() {
    // 设置初始语言
    this.setLocal(this.$i18n.locale);
    console.log("登录信息", this.$i18n.locale);

    get_website_data().then((res) => {
      console.log("登录信息", res.body.logo_url);
      localStorage.setItem('logo_url',res.body.logo_url);
      if (this.$i18n.locale == "zh-CN") {
        this.name = res.body.web_name[0].zh;
      }
        if (this.$i18n.locale == "en-US") {
        this.name = res.body.web_name[0].en;
      }
    });
  },
};
</script>
